import { getProductWithCategory, getProductWithSubCategory, getUniqueCategories, getUniqueSubCategories } from "../../helpers/product";
import React from "react";
import { setActiveSort } from "../../helpers/product";

const ShopProductSubCategory = ({ products, getSortParams, sideSpaceClass, value, setSortValues, category }) => {
  const uniqueSubCategories = getUniqueSubCategories(products)?.sort();

  return (
    <div className="row g-4">
      {uniqueSubCategories?.map((subcategory) => {
        const numArt = getProductWithSubCategory(products, category, subcategory);
        if (subcategory === "" || numArt <= 0) return null;
        
        return (
          <div className="col-12 col-md-3" key={subcategory} onClick={e => {
            document.querySelector("#allCategories").classList.remove("active")
            if (e.currentTarget.classList.contains("active")) getSortParams("subcategory", subcategory, "-");
            else getSortParams("subcategory", subcategory, "+");
            setActiveSort(e);
          }}>
            <div className="card text-center shadow-sm border-0">
              <div className="card-body">
                <div className="p-3 bg-primary text-white rounded-circle d-inline-block mb-3">
                  <svg className="bi" width="32" height="32" fill="currentColor">
                    {/* Puoi aggiungere qui l'icona appropriata */}
                  </svg>
                </div>
                <h5 className="card-title">{subcategory}</h5>
                <p className="card-text text-muted">{numArt} prodotti</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopProductSubCategory;
